var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDown = function SvgDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 10,
    "data-width-20": 12,
    "data-width-24": 14,
    viewBox: "0 0 14 7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.746 6.516a.78.78 0 0 1-.48-.17l-6-5a.766.766 0 1 1 1-1.16l5.48 4.6 5.52-4.6a.765.765 0 1 1 1 1.16l-6 5a.78.78 0 0 1-.52.17"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDown);
export default ForwardRef;